import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import styled from '@emotion/styled';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ConfluenceLogo } from '@atlaskit/logo';
import { B200, N300, N30A } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { ANALYTICS_CHANNEL } from '../analytics';
var Container = styled.div({
  fontSize: 12,
  height: 52,
  color: "var(--ds-text-subtle, ".concat(N300, ")"),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderTop: "2px solid ".concat("var(--ds-border, ".concat(N30A, ")"))
});
var ContentWrapper = styled.div({
  height: 16,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end'
});
var LogoWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: "0px 0px 0px ".concat("var(--ds-space-100, 8px)")
});
var Link = styled.a({
  '&, &:focus, &:active, &:hover': {
    color: 'inherit',
    outline: 'none',
    boxShadow: 'none',
    textDecoration: 'none'
  }
});
export var Footer = function Footer(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "footer-container"
  }, url ? /*#__PURE__*/React.createElement(ContentAction, {
    tooltipText: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "embedded.confluence.footer.hover.text",
      description: "Hover text on Confluence Footer Content",
      defaultMessage: "View in Confluence"
    }),
    href: url
  }, function (_ref2) {
    var isHovered = _ref2.isHovered;
    return /*#__PURE__*/React.createElement(Content, {
      isHovered: isHovered
    });
  }) : /*#__PURE__*/React.createElement(Content, null));
};
var Content = function Content(_ref3) {
  var isHovered = _ref3.isHovered;
  return /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "embedded.confluence.footer.prefix",
    description: "Prefix label on Confluence Logo",
    defaultMessage: "Powered by"
  }), /*#__PURE__*/React.createElement(LogoWrapper, null, /*#__PURE__*/React.createElement(ConfluenceLogo, {
    size: "xsmall"
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    ,
    iconColor: isHovered ? "var(--ds-icon-brand, ".concat(B200, ")") : "var(--ds-icon-subtle, ".concat(N300, ")")
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    ,
    textColor: "var(--ds-text-subtle, ".concat(N300, ")")
  })));
};
var ContentAction = function ContentAction(_ref4) {
  var children = _ref4.children,
    tooltipText = _ref4.tooltipText,
    href = _ref4.href;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var handleClick = function handleClick() {
    createAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'confluenceFooter',
      source: 'embeddedConfluenceViewPageScreen',
      eventType: 'ui'
    }).fire(ANALYTICS_CHANNEL);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipText
  }, /*#__PURE__*/React.createElement(Link, {
    href: href,
    target: "_blank",
    onMouseEnter: function onMouseEnter() {
      setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsHovered(false);
    },
    onClick: handleClick,
    "data-testid": "link"
  }, children({
    isHovered: isHovered
  })));
};